<div id="add-booking" >
  <div class="modal-header black">
      <h2 class="modal-title" id="myModalLabel" translate>lblUploadDocument</h2>
      <button type="button" class="close" (click)="activeModal.close({success: false})" aria-label="Center Align"><span  aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
          <form class="col-12" [formGroup] = "uploadImagedata" enctype="multipart/form-data">
              <div class="row mt-3">
                  <div class="col-10 mt-10 ml-20">
                      <label for="comment"><span translate>lblComment</span><strong class="mlt6 required" style="color: red;"> *
                        </strong></label>
                          <textarea class="form-control" name="textDescription" maxlength="100" formControlName="comment" 
                          [ngClass]="{'is-invalid': (cpf.comment.touched || cpf.comment.dirty) && cpf.comment.errors}" required> </textarea> 
                  </div>
              </div>
                  <div class="row mt-3">
                      <div class="col-6">
                          <span>
                              <label class="btn btn-primary" for="select-files"
                                translate>lblUploadDocument</label>
                              <input type="file" id="select-files" multiple="multiple" hidden name="FUImage" [attr.accept]="allowExtension"
                                (change)="showPreview($event)">
                            </span>
                          <p class="text-muted ml-20 mt-3">
                              <span translate class="fnt10">lblNote</span><span class="fnt10">:
                              </span><span translate class="fnt10">lblFileSizeMax50MB</span>
                          </p>
                      </div>
                      <div class="col-6">
                          <!-- Image Preview -->
                          <div id="imagePreview" *ngIf= "DocumentsArray?.length > 0" style="display: flex;flex-direction: row;flex-wrap: wrap;">
                              <div *ngFor="let item of DocumentsArray;let i = index">
                                <div *ngIf="item.isImage" class="position-relative m-1">
                                  <img class="border p-1" [src]="item.src | safe:'url'" id="UploadImage" alt="Logo does not found." 
                                  onError="this.onerror=null; this.src='../../../../assets/images/no-image-icon.png'"
                                  width="100px" height="100px">
                                  <span type="button" style="position: absolute; right: 0; top: 0; z-index: 10; color: #cc0935; right: 6px"  aria-label="Close" (click)="RemoveImage(i)">
                                      <em class="fas fa-times"></em>
                                  </span>
                                </div>
                                <div *ngIf="!item.isImage" class="position-relative m-1 wordbreak" style="padding-right: 30px;">
                                    {{item.image}}
                                    <span type="button" style="position: absolute; right: 0 !important; top: 0; z-index: 10; color: #cc0935; right: 6px;    background: white;width: 20px;height: 20px;text-align: center;display: inline-block;"  aria-label="Close" (click)="RemoveImage(i)">
                                      <em class="fas fa-times"></em>
                                  </span>
                                </div>
                                </div>
                          </div>
                      </div>
                  </div>
          </form>
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary btn-green mr-sm-2" translate aria-label="Center Align" [disabled]="uploadImagedata.invalid || !(imageSelected)" (click)="UploadImage(uploadImagedata.value)">lblSave</button>

        <button (click)="activeModal.close({success: false})" class="btn btn-primary " aria-label="Center Align"
        translate>lblCancel</button>
      </div>
  </div>
  
